import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { ExternalLink, ShoppingBag } from "lucide-react";

const AffiliateWidget = () => {
  const { data: products = [] } = useQuery({
    queryKey: ["affiliate-products"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("affiliate_products")
        .select("*")
        .eq("active", true)
        .order("position", { ascending: true })
        .limit(4);
      if (error) throw error;
      return data ?? [];
    },
  });

  if (products.length === 0) return null;

  return (
    <div className="my-10 p-6 bg-secondary/50 rounded-2xl border border-border/50">
      <div className="flex items-center gap-2 mb-4">
        <ShoppingBag className="w-5 h-5 text-primary" />
        <h3 className="font-display text-lg font-semibold">Recommended Products</h3>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {products.map((product: any) => (
          <a
            key={product.id}
            href={product.affiliate_link}
            target="_blank"
            rel="noopener noreferrer sponsored"
            className="group block rounded-xl overflow-hidden border border-border/50 bg-card hover:shadow-md transition-all"
          >
            {product.image_url && (
              <div className="aspect-square overflow-hidden bg-muted">
                <img
                  src={product.image_url}
                  alt={product.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                />
              </div>
            )}
            <div className="p-3">
              <p className="font-body text-sm font-medium truncate">{product.name}</p>
              {product.price_display && (
                <p className="text-primary font-body text-sm font-bold mt-0.5">{product.price_display}</p>
              )}
              <div className="flex items-center gap-1 mt-1.5 text-xs text-muted-foreground font-body">
                {product.source === "internal" ? (
                  <span>Shop now</span>
                ) : (
                  <>
                    <span>{product.source}</span>
                    <ExternalLink className="w-3 h-3" />
                  </>
                )}
              </div>
            </div>
          </a>
        ))}
      </div>
      <p className="text-[10px] text-muted-foreground font-body mt-3 text-center">
        Some links may be affiliate links. We may earn a small commission at no extra cost to you.
      </p>
    </div>
  );
};

export default AffiliateWidget;
